import { CRUDFactory } from '../CRUDFactory';

export default CRUDFactory('/region-settings');
